import React, { useState, useEffect, useContext } from "react";
import {
    Button,
    Grid
} from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import { ActionContext } from 'src/contexts/ActionContext';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from 'src/components/Button/IconButton';
import AddBoxIcon from '@mui/icons-material/AddBox';
import DialogOtherActionsNextYear from "src/components/Dialog/FicheEEPBM/DialogOtherActionsNextYear";
import EmptyMessage from "src/components/Message/EmptyMessage";
import { toolsService } from "src/services";
import OtherActionsNextYearItem from "./OtherActionsNextYearItem";
import ASMDialogConfirmation from "src/components/Dialog/ASMDialogConfirmation";
import { otherActionsNextYearService } from 'src/services';
import { OtherActionsNextYearModel } from 'src/models/businessManager/businessManager.model';
import ASMAlert from "src/components/Alert";

function OtherActionsNextYear(props) {
    const { REACT_APP_NOTIFICATION_DURATION } = process.env;
    const { t } = useTranslation();
    const { actionToggle } = useContext(ActionContext);
    const isVisu = !actionToggle;
    const [data, setData] = useState<OtherActionsNextYearModel[]>([]);
    const [displayAlert, setDisplayAlert] = useState<boolean>(false);
    const [displayAlertError, setDisplayAlertError] = useState<boolean>(false);
    const [openDialogUpdate, setOpenDialogUpdate] = useState(false);
    const [openDialogDelete, setOpenDialogDelete] = useState<boolean>(false);
    const [idToDelete, setIdToDelete] = useState({
        index: 0,
        id: 0
    });
    const [state, setState] = React.useState<OtherActionsNextYearModel>({
        id: 0,
        idEa: 0,
        actionType: '',
        motivationJustification: '',
        implementationSystems: ''
    });
    const idEEPBM = props.idEEPBM;
    useEffect(() => {
        if (idEEPBM != 0) {
            otherActionsNextYearService.getByIdEa(idEEPBM).then(response => {
                if (response.data.success) {
                    setData(response.data.data)
                }
            });
        }
    }, [idEEPBM]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setState({
            ...state,
            [name]: value
        });
    }

    const handleCloseDialogUpdate = () => {
        setState({
            id: 0,
            idEa: 0,
            actionType: '',
            motivationJustification: '',
            implementationSystems: ''
        })
        setOpenDialogUpdate(false);
    }

    const handleOpenDialogDelete = (i, id) => {
        setIdToDelete({
            index: i,
            id: id
        })
        setOpenDialogDelete(true)
    }
    const handleClickUpdate = () => {
        if (state.actionType != '' && state.motivationJustification != '' && state.implementationSystems != '') {
            state.idEa = idEEPBM;
            otherActionsNextYearService.insert(state).then(response => {
                if (response.data.success) {
                    setData([...data, response.data.data])
                    setOpenDialogUpdate(false);
                    setState({
                        id: 0,
                        idEa: 0,
                        actionType: '',
                        motivationJustification: '',
                        implementationSystems: ''
                    })
                    setDisplayAlert(true);
                    setTimeout(() => {
                        setDisplayAlert(false);
                    }, parseInt(REACT_APP_NOTIFICATION_DURATION) * 1000);
                } else {
                    setDisplayAlertError(true);
                    setTimeout(() => {
                        setDisplayAlertError(false);
                    }, parseInt(REACT_APP_NOTIFICATION_DURATION) * 1000);
                }
            }).catch(err => {
                setDisplayAlertError(true);
                setTimeout(() => {
                    setDisplayAlertError(false);
                }, parseInt(REACT_APP_NOTIFICATION_DURATION) * 1000);
            });
        } else {
            setDisplayAlertError(true);
            setTimeout(() => {
                setDisplayAlertError(false);
            }, parseInt(REACT_APP_NOTIFICATION_DURATION) * 1000);
        }
    }
    const handleClickDelete = () => {
        otherActionsNextYearService.deleteOtherActionsNextYear(idToDelete.id, idEEPBM).then(response => {
            if (response.data.success && response.data.data) {
                let array = [...data];
                array.splice(idToDelete.index, 1);
                setData(array);
                setDisplayAlert(true);
                setTimeout(() => {
                    setDisplayAlert(false);
                }, parseInt(REACT_APP_NOTIFICATION_DURATION) * 1000);
                setOpenDialogDelete(false);
            } else {
                setDisplayAlertError(true);
                setTimeout(() => {
                    setDisplayAlertError(false);
                }, parseInt(REACT_APP_NOTIFICATION_DURATION) * 1000);
            }
        }).catch(err => {
            setDisplayAlertError(true);
            setTimeout(() => {
                setDisplayAlertError(false);
            }, parseInt(REACT_APP_NOTIFICATION_DURATION) * 1000);
        });
    }

    return (
        <>
            <ASMAlert message={t('action.success')} severity="success" open={displayAlert} />
            <ASMAlert message={t('action.error')} severity="error" open={displayAlertError} />
            <Grid item xs={12}>
                <h3 style={{ fontStyle: 'italic', fontWeight: 'normal', marginLeft: 2, marginRight: 2 }}>
                    <Trans>eepBm.otherActionsNPlus1.label</Trans>
                </h3>
            </Grid>
            <div style={{ backgroundColor: '#ffffff', marginTop: -10 }} >
                <Grid container direction="row" alignItems="stretch" style={{
                    backgroundColor: '#2c9a42',
                    color: '#ffffff',
                    height: 50,
                    textAlign: 'center',
                    fontSize: 12,
                    textTransform: 'uppercase',
                    marginTop: 15,
                    borderRadius: 3
                }}>
                    <Grid item xs={3} >
                        <h3><Trans>eepBm.otherActionsNPlus1.title1</Trans></h3>
                    </Grid>
                    <Grid item xs={4} >
                        <h3><Trans>eepBm.otherActionsNPlus1.title2</Trans></h3>
                    </Grid>
                    <Grid item xs={4} >
                        <h3><Trans>eepBm.otherActionsNPlus1.title3</Trans></h3>
                    </Grid>
                    <Grid item xs={1} ></Grid>
                </Grid>
                <Grid container direction="row" alignItems="stretch" sx={{ padding: 1 }} spacing={1}>
                    {data.length != 0 ?
                        data.map((item, index) => {
                            return (
                                <OtherActionsNextYearItem
                                    key={item.id}
                                    data={item}
                                    lineColor={toolsService.getLineColor(index)}
                                    index={item.id}
                                    deleteComponent={
                                        <>
                                            <IconButton
                                                variant="contained"
                                                color="error"
                                                width={40}
                                                icon={
                                                    <DeleteIcon
                                                        style={{ fontSize: 25 }}
                                                        onClick={() => handleOpenDialogDelete(index, item.id)}
                                                    />
                                                }
                                                disabled={isVisu}
                                            />
                                        </>
                                    }
                                />
                            )
                        })
                        :
                        <EmptyMessage withAddition={true} />
                    }
                </Grid>
                {!isVisu &&
                    <Button variant="contained"
                        style={{ backgroundColor: '#ffffff', color: '#00b0be', border: '2px #00b0be solid', marginRight: 20 }}
                        startIcon={<AddBoxIcon style={{ fontSize: 25 }} />}
                        onClick={() => setOpenDialogUpdate(true)}
                    >
                        <Trans>button.add</Trans>
                    </Button>
                }
            </div>
            <DialogOtherActionsNextYear
                data={state}
                handleChange={handleChange}
                openDialogUpdate={openDialogUpdate}
                handleCloseDialogUpdate={handleCloseDialogUpdate}
                handleClickUpdate={handleClickUpdate}
                title={t('eepBm.otherActionsNPlus1.addTitle')}
            />
            <ASMDialogConfirmation
                title={t('dialog.confirmation')}
                text={t('deleteMessage')}
                open={openDialogDelete}
                onConfirm={handleClickDelete}
                onClose={() => setOpenDialogDelete(false)}
                data={3}
            />
        </>
    );
}

export default OtherActionsNextYear;